<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onLaunch, onShow } from '@dcloudio/uni-app'
import { useCommonData } from '@/stores/commom'
import { useUserStore } from '@/core/services/auth-credentials'
import { publicParamsApi } from './core/apis/base-api'
import Singlestore from '@/static/js/singlestore' // 单店小程序
import '@/static/icon/iconfont.css'


import klUserAppSdk from '@/hooks/kl_user_app_sdk.js'
import initFDBase from 'fdmer'
import type { FDHostInterface } from 'fdmer'
klUserAppSdk()
initFDBase()
const fdHost: FDHostInterface = window.getFDHostInstance()


const { getSystemInfo, getLocation, getAcountInfo, reportApiFun } = useCommonData()
const { isApp, isAndroid, isIOS, receiveAddress, isChooseAdr, urlParams, isPc, isFlutter } =
  storeToRefs(useCommonData())
const { setProfile, setStatusBarHeight, setPegePositionData, clearProfile } = useUserStore()
const { profile } = storeToRefs(useUserStore())
let pcLayoutResizeTimer: ReturnType<typeof setTimeout> | null = null
let hasBindPcLayoutResize = false

const MOBILE_VIEWPORT_RE =
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i

const setMobileViewportFallback = () => {

  const width = window.innerWidth || document.documentElement.clientWidth
  const screenWidth = window.screen?.width || 0
  const isCompactScreen = screenWidth > 0 && screenWidth <= 500
  const isMobileViewport = MOBILE_VIEWPORT_RE.test(navigator.userAgent) || isCompactScreen
  const isAbnormalWideMobileViewport = isMobileViewport && width > 750
  const rpxBaseWidth = isMobileViewport && width > 960 ? width : width <= 960 ? width : 375

  document.documentElement.style.fontSize = `${rpxBaseWidth / 23.4375}px`
  document.body?.classList.toggle('fd-mobile-wide-viewport', isAbnormalWideMobileViewport)

}


setMobileViewportFallback()


// 公共参数
const initPublicParams = async () => {
  let api = new publicParamsApi()
  api.setParams = {
    type: 'client',
    lang: 'cn',
  }
  let { data } = await api.getPublicParams()
  useCommonData().publicParams = data
}

// 获取路由上用户信息
const getHrefUserInfo = () => {
  const urlparams = new URLSearchParams(window.location.search)
  urlParams.value = urlparams
  let uid = urlparams.get('uid') || ''
  let token = urlparams.get('token') || ''
  // 本地或局域网访问时注入测试账号
  const host = window.location.hostname
  const isLocalOrLan =
    host === 'localhost' ||
    host === '127.0.0.1' ||
    /^10\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host) ||
    /^192\.168\./.test(host)
  if (isLocalOrLan) {
    const env = import.meta.env.VITE_ENV
    if (env === 'dev') {
      // uid = '13531'
      // token = '80ada33b369eb2858efe085d60fdb19e7fd62668'
      uid = '10000056'
      token = '569c95d561cf488c2c3478f5c1da0848fbc3620a'
      // uid = '32207'
      // token = '0122f35eac118c89c12eebbf08c813c16358ffde'
    } else if (env === 'staging' || env === 'preview') {
      uid = '144478'
      token = '743a9d4df11ffd5af7c2913f24a9c55e98450265'
    } else if (env === 'production') {
      uid = '243929'
      token = '6e7eefaf432030235742df1cd95ac6b479f66e0a'
    }
  }
  if (uid && token) {
    setProfile({ uid, token })
  }
}

// 小程序检查更新
const autoUpdate = () => {










































}

// 处理微信小程序相关
const handleWeiXin = (options?: AnyObject) => {
























}

// 处理app相关
const handleApp = () => {

  new Singlestore()
  const isGroupon = window.location.pathname.split('/')[1] === 'grouponPages' ? true : false
  const isOrder = window.location.pathname === '/me/order/index' ? true : false
  const isIntegral = window.location.pathname.startsWith('/me/integral')

  const getUserInfo = () => {
    if (isApp.value) {
      let userInfo, location
      try {
        userInfo = fdHost.appParams.getUserInfo() as any
        location = fdHost.appParams.getLocation() as any
        useCommonData().appParams = fdHost.appParams.getHeaderParams()

        if (!userInfo || (!userInfo.uid && !userInfo.token)) clearProfile()
        else setProfile(userInfo)

        receiveAddress.value.lat = location.lat || ''
        receiveAddress.value.lng = location.lng || ''
      } catch (error) {
        getHrefUserInfo()
      }
    } else if (isFlutter.value) {
      const flutter = window.KLifeUserApp
      try {
        flutter.device.info((res: any) => {
          if (res.data) {
            useCommonData().appParams = res.data
          }
        })
        flutter.location.current((res: any) => {
          if (res.data) {
            receiveAddress.value.lat = res.data.latitude || ''
            receiveAddress.value.lng = res.data.longitude || ''
          }
        })
        flutter.creds.get((res: any) => {
          if (res.data) {
            const userInfo = {
              token: res.data.token,
              ...res.data.info,
            }
            setProfile(userInfo)
          } else {
            clearProfile()
          }
        })
      } catch (error) {
        getHrefUserInfo()
      }
    }
  }

  if (isFlutter.value) {
    window.KLifeUserApp.appbar.setVisibility(false)
  }

  if (isGroupon || isOrder || isIntegral) {
    if (isGroupon) {
      window.addEventListener('click', (e) => {
        setPegePositionData(e.clientX, e.clientY)
      })
    }

    if (isApp.value) {
      if (isAndroid.value) {
        fdHost.navBar.hide()
      } else if (isIOS.value) {
        setTimeout(() => {
          setStatusBarHeight(uni.getWindowInfo().statusBarHeight)
          setTimeout(() => {
            fdHost.navBar.hide()
          }, 100)
        }, 200)
      }
    }
  }

  if (isApp.value || isFlutter.value) getUserInfo()
  window.loginSuccess = getUserInfo
  window.iosLoginSuccess = getUserInfo

}

// 处理pc相关
const setPcLayoutStyle = () => {
  setMobileViewportFallback()

  const body = document.getElementsByTagName('body')[0]
  const tabbar = document.getElementsByClassName('uni-tabbar-bottom')[0] as HTMLElement | undefined
  const tabbarChild = document.getElementsByClassName('uni-tabbar')[0] as HTMLElement | undefined
  const viewWidth = window.innerWidth || document.documentElement.clientWidth
  const shouldUsePcLayout = isPc.value && viewWidth >= 750

  if (!body) return

  if (shouldUsePcLayout) {
    const sideSpace = Math.max((viewWidth - 750) / 2, 0)
    body.style.maxWidth = '750px'
    body.style.margin = '0 auto'
    if (tabbar) {
      tabbar.style.left = `${sideSpace}px`
      tabbar.style.right = `${sideSpace}px`
      tabbar.style.maxWidth = '750px'
    }
    if (tabbarChild) {
      tabbarChild.style.left = `${sideSpace}px`
      tabbarChild.style.right = `${sideSpace}px`
      tabbarChild.style.backgroundColor = 'rgb(255, 255, 255)'
      tabbarChild.style.backdropFilter = 'none'
    }
    return
  }

  body.style.maxWidth = ''
  body.style.margin = ''
  if (tabbar) {
    tabbar.style.left = ''
    tabbar.style.right = ''
    tabbar.style.maxWidth = ''
  }
  if (tabbarChild) {
    tabbarChild.style.left = ''
    tabbarChild.style.right = ''
    tabbarChild.style.backgroundColor = ''
    tabbarChild.style.backdropFilter = ''
  }
}

const handelPc = () => {

  if (!isApp.value && !isFlutter.value) getHrefUserInfo()

  setPcLayoutStyle()
  if (!hasBindPcLayoutResize) {
    hasBindPcLayoutResize = true
    window.addEventListener('resize', () => {
      if (pcLayoutResizeTimer) clearTimeout(pcLayoutResizeTimer)
      pcLayoutResizeTimer = setTimeout(async () => {
        await getSystemInfo()
        setPcLayoutStyle()
      }, 100)
    })
  }

}

const isPaymentChainPage = () => {
  let isTargetPage = false

  const path = window.location.pathname.replace(/\/+$/, '')
  isTargetPage = path.endsWith('/me/pay/paymentChain')

  return isTargetPage
}

onLaunch(async (options?: AnyObject) => {
  console.log(options, 2)
  uni.removeStorage({ key: 'merSearch' })
  await getSystemInfo()
  handleWeiXin(options)
  handleApp()
  handelPc()
  if (!isPaymentChainPage()) initPublicParams()
})

onShow(() => {
  autoUpdate()

  if (!isPaymentChainPage() && !isApp.value && !isFlutter.value) {
    reportApiFun('onForeground')
  }
})
</script>
<style lang="scss">
@import '@/styles/base.scss';
@import '@/styles/font.scss';
@import '@/styles/common.scss';


body {
  overflow-x: hidden !important;
}

body.fd-mobile-wide-viewport {
  max-width: none !important;
  margin: 0 !important;
}

body.fd-mobile-wide-viewport uni-page {
  max-width: none !important;
  margin: 0 !important;
}


</style>
